import { Formik } from "formik";
import React from "react";
import { Table } from "react-bootstrap";
import { CardFooter } from "../../../../../_metronic/_partials/controls";

export default function BenefisImportTable({
  dataTable,
  saveData,
  validateData,
  isValidation,
  errorRows
}) {
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{}}
        onSubmit={() => saveData()}
      >
        {({ handleSubmit }) => {
          return (
            <>
              <Table responsive={true}>
                <thead>
                  <tr>
                    <th>No</th>
                    <th className="text-nowrap">Nama</th>
                    <th className="text-nowrap">Telepon</th>
                    <th className="text-nowrap">Email</th>
                    <th className="text-nowrap">Kategori Penerima Manfaat</th>
                    <th className="text-nowrap">Provinsi</th>
                    <th className="text-nowrap">Kota</th>
                    <th className="text-nowrap">Kecamatan</th>
                    <th className="text-nowrap">Kode Pos</th>
                    <th className="text-nowrap">No Ktp</th>
                    <th className="text-nowrap">Status Hidup</th>
                    <th className="text-nowrap">Status Aktif</th>
                  </tr>
                </thead>
                <tbody>
                  {dataTable.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td className="text-nowrap">{item.name}</td>
                        <td className="text-nowrap">{item.hp}</td>
                        <td className="text-nowrap">{item.email}</td>
                        <td className="text-nowrap">{item.benefis_category}</td>
                        <td className="text-nowrap">{item.province}</td>
                        <td className="text-nowrap">{item.city}</td>
                        <td className="text-nowrap">{item.district}</td>
                        <td className="text-nowrap">{item.postal_code}</td>
                        <td className="text-nowrap">{item.nik}</td>
                        <td className="text-nowrap">{item.is_alive}</td>
                        <td className="text-nowrap">{item.is_active}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <CardFooter>
                {isValidation ? (
                  <>
                    {dataTable.length > 0 && errorRows.length === 0 && (
                      <>
                        <button
                          className="btn btn-warning mx-1 float-right"
                          onClick={validateData}
                        >
                          Validasi
                        </button>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {dataTable.length > 0 && (
                      <>
                        <button
                          className="btn btn-primary mx-1 float-right"
                          onClick={handleSubmit}
                        >
                          Simpan
                        </button>
                      </>
                    )}
                  </>
                )}
              </CardFooter>
            </>
          );
        }}
      </Formik>
    </>
  );
}
